var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preheat"},[_c('div',{staticClass:"preheatimg"},[_c('img',{attrs:{"src":"https://musicwow.oss-cn-shenzhen.aliyuncs.com/single_page/activity/match_notice_20201020.jpg","alt":""}})])])
}]

export { render, staticRenderFns }